import ContentLoader from "react-content-loader";

type Props = {
  count: number;
};

export const SkeletonCoupon = ({ count = 1 }: Props) => {
  const bgColor = "#fbfbfb";
  const contentHeight = 130;
  const itemSkeleton = Array.from({ length: count }).map((_, index) => (
    <div key={index} className="col-lg-6 col-12 mb-2">
       <ContentLoader
        speed={2}
        width={"100%"}
        height={contentHeight}
        viewBox={`0 0 100% ${contentHeight}`}
        backgroundColor={bgColor}
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="10" ry="10" width="100%" height="130" />
      </ContentLoader>
    </div>
  ));
  return <>{itemSkeleton}</>;
};
